import React, { useState, useEffect } from "react";
import {
  Navbar,
  Collapse,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button
} from "@material-tailwind/react";
import { Bars3Icon, XMarkIcon,ChevronDownIcon } from "@heroicons/react/24/outline";
import { BeakerIcon, UserIcon, BriefcaseIcon } from "@heroicons/react/24/solid";
import {
  useAddress,
  useMetamask,
  useLogin,
  useLogout,
  useUser,
} from "@thirdweb-dev/react";
import axios from "axios"; // Ensure axios is installed
import { useNavigate, useLocation } from "react-router-dom";

function NavList({ onPatientLogin, onProviderLogin }) {
  const [isLoggedInn, setIsLoggedInn] = useState(false);
  const [userKey, setUserKey] = useState(0); // Key to force re-render
  const address = useAddress();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const connectWithMetamask = useMetamask();
  const { login, isLoading } = useLogin();
  const { logout } = useLogout();
  const { user, isLoggedIn } = useUser();
  const [loginMenuOpen, setLoginMenuOpen] = useState(false);

  

  useEffect(() => {
    // Check if user is logged in and update state
    setIsLoggedInn(localStorage.getItem("authToken") != null);
  }, [userKey]); // Dependency on userKey to recheck login status

  // This will handle the login process
  // Assuming 'address' is either a global variable or imported from another module.
  // If it's not, consider adding it as a function parameter or ensuring it's correctly defined.

  // Use a configuration file or environment variables for API base URLs
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:3001";
  
  const handleLogin = async (userType) => {
    try {
      if (!address) {
        await connectWithMetamask();
      } else {
        const nonceEndpoint = `${API_BASE_URL}/api/auth/${userType}/challenge`;
        const {
          data: { nonce },
        } = await axios.get(nonceEndpoint, { params: { address } });

        // Logic for login - uncomment or modify as per actual use
        // await login();

        const loginEndpoints = {
          patient: `${API_BASE_URL}/api/auth/patient/login`,
          provider: `${API_BASE_URL}/api/auth/provider/login`,
        };

        const authResponse = await axios.post(loginEndpoints[userType], {
          address,
          userType,
        });
        const { token } = authResponse.data;

        // Consider more secure storage methods for tokens
        localStorage.setItem("authToken", token);

        if (userType === "patient") {
          console.log("patient");
          onPatientLogin();
          navigate("/patient-dashboard");
        } else {
          console.log("providers")
          onProviderLogin();
          navigate("/dashboard");
          // Navigate to provider dashboard or another page if necessary
        }

        //userType === "patient" ? onPatientLogin() : onProviderLogin();
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    setIsLoggedInn(false);
    setUserKey((prevKey) => prevKey + 1); // Update key to force re-render
    navigate("/");
  };


  const isAuthenticated = () => {
    const token = localStorage.getItem("authToken");
    return !!token; // returns true if token exists, false otherwise
  };

  const handleProfile = () => {
    if (currentPath == "/patient-dashboard") {
      navigate("/signup");
    } else {
      onProviderLogin();
      navigate("/providers-signup");
      // Navigate to provider dashboard or another page if necessary
    }
  }

  const handleDashboard = () => {
    if (currentPath == "/signup") {
      navigate("/patient-dashboard");
    } else {
      onProviderLogin();
      navigate("/dashboard");
      // Navigate to provider dashboard or another page if necessary
    }
  }

  return (
    <ul className="my-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
      {isAuthenticated() ? (
        <>
          <Tooltip content={`${address}`}>
            <span className="flex items-center gap-2 px-4 py-2 rounded-lg shadow-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              {`${address}`}
            </span>
          </Tooltip>
          {
            (currentPath != "/signup" && currentPath !="/providers-signup")?
            <Button  variant="text" className="flex items-center gap-2" onClick={handleProfile}>
          <UserIcon className="h-5 w-5 mr-1" />
          Profile
        </Button>: <Button  variant="text" className="flex items-center gap-2" onClick={handleDashboard}>
          <BeakerIcon className="h-5 w-5 mr-1" />
          Dashboard
        </Button>
          }
          
  
          <Tooltip content="Logout">
            <button onClick={handleLogout}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                />
              </svg>
            </button>
          </Tooltip>
        </>
      ) : (
        <>
          {/* <button onClick={() => handleLogin("patient")}>Patient Login</button>
          <button onClick={() => handleLogin("provider")}>
            Provider Login
          </button> */}
           {/* Login Dropdown: */}
           <Menu open={loginMenuOpen} handler={setLoginMenuOpen}>
      <MenuHandler>
        <Button color="blue-gray" variant="text" className="flex items-center gap-2">
          Login
          <ChevronDownIcon className="h-4 w-4" />
        </Button>
      </MenuHandler>
      <MenuList>
        <MenuItem onClick={() => handleLogin('patient')} className="flex items-center">
          <UserIcon className="h-5 w-5 mr-2" />
          Patient
        </MenuItem>
        <MenuItem onClick={() => handleLogin('provider')} className="flex items-center">
          <BriefcaseIcon className="h-5 w-5 mr-2" />
          Provider
        </MenuItem>
      </MenuList>
    </Menu>
          {/* <button onClick={() => {
            navigate("/signup")
          }}>Patient Sign Up</button>
          <button onClick={()=>{
            navigate("providers-signup")
          }}>Provider Sign Up</button> */}
        </>
      )}
    </ul>
  );
}

export function SignupNavbar() {
  const [openNav, setOpenNav] = useState(false);

  useEffect(() => {
    const handleWindowResize = () =>
      window.innerWidth >= 960 && setOpenNav(false);
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const handlePatientLogin = () => {
    // Logic after patient login, e.g. redirect
  };

  const handleProviderLogin = () => {
    // Logic after provider login, e.g. redirect
  };

  return (
    <Navbar className="mx-auto max-w-screen-xl px-6 py-3">
      <div className="flex items-center justify-between text-blue-gray-900">
        <Typography
          as="a"
          href="#"
          variant="h6"
          className="mr-4 cursor-pointer py-1.5"
          color="blue"
        >
          fuor.health
        </Typography>
        <div className="hidden lg:block">
          <NavList
            onPatientLogin={handlePatientLogin}
            onProviderLogin={handleProviderLogin}
          />
        </div>
        <IconButton
          variant="text"
          className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
          ripple={false}
          onClick={() => setOpenNav(!openNav)}
        >
          {openNav ? (
            <XMarkIcon className="h-6 w-6" />
          ) : (
            <Bars3Icon className="h-6 w-6" />
          )}
        </IconButton>
      </div>
      <Collapse open={openNav}>
        <NavList
          onPatientLogin={handlePatientLogin}
          onProviderLogin={handleProviderLogin}
        />
      </Collapse>
    </Navbar>
  );
}
